/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentFee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TreatmentFee({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Summary/TreatmentFee"
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let paymentPlanTreatmentFeeValueData = fromData.useDataFormat({ viewPath,
context: 'payment_plan',
path: 'treatment_fee',
format: fromFormat.numberMoney,
})
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
  return (<React.Fragment
>
<div
  data-testid="TreatmentFee.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1CHdJW': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--ml-2-Z1CHdJW': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-Z1CHdJW': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Treatment fee"
 color={dtColorsBlack}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.treatment_fee"
 format="/Data/format.js numberMoney"
 text={paymentPlanTreatmentFeeValueData}
 weight="medium"
 color={dtColorsGreen700}
/>
</div>
{children}
</React.Fragment>)
}